/**
 * Handles errors from Supabase Edge Functions.
 * It extracts the error body from the response context if available.
 */
export const handleEdgeFunctionError = async (error: any): Promise<any> => {
  if (!error) return null;

  // Check if error has a context object (common in Supabase SDK for non-2xx responses)
  if (error.context && typeof error.context.json === 'function') {
    try {
      const errorBody = await error.context.json();
      // If the body has a message or error property, return that as the error
      return errorBody;
    } catch (e) {
      console.error('[handleEdgeFunctionError] Failed to parse error context json:', e);
    }
  }

  // If no context or parsing failed, return the original error
  return error;
};
